(function (global){
/*global _:true*/
'use strict';

// Set debug to false to disable all console.logs
var App = global.App = {
	debug: 			true,
	initialized: 	false,
	resizers: 		[]
};

var	$ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

// Turn of console.log for unsupportedbrowsers and when debug is set to false;
require('./modules/_console');


$( document ).ready(function() {
	console.log('Eenvoud Foundetion');
	//$('nav#main-nav a').smoothScroll({offset: -34});
	_.each(App.resizers, function(resizer) {
		resizer();
	});

	
});

$(window).load(function() {
	App.initialized = true;
	//console.log(App.initialized);
	
	_.each(App.resizers, function(resizer) {
		resizer();
	});

});

var resizeTimer;

$(window).resize(function() {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function() {
		_.each(App.resizers, function(resizer) {
			resizer();
		});
	},100);
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9qcy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsiLypnbG9iYWwgXzp0cnVlKi9cclxuJ3VzZSBzdHJpY3QnO1xyXG5cclxuLy8gU2V0IGRlYnVnIHRvIGZhbHNlIHRvIGRpc2FibGUgYWxsIGNvbnNvbGUubG9nc1xyXG52YXIgQXBwID0gZ2xvYmFsLkFwcCA9IHtcclxuXHRkZWJ1ZzogXHRcdFx0dHJ1ZSxcclxuXHRpbml0aWFsaXplZDogXHRmYWxzZSxcclxuXHRyZXNpemVyczogXHRcdFtdXHJcbn07XHJcblxyXG52YXJcdCQgPSAodHlwZW9mIHdpbmRvdyAhPT0gXCJ1bmRlZmluZWRcIiA/IHdpbmRvd1snalF1ZXJ5J10gOiB0eXBlb2YgZ2xvYmFsICE9PSBcInVuZGVmaW5lZFwiID8gZ2xvYmFsWydqUXVlcnknXSA6IG51bGwpO1xyXG5cclxuLy8gVHVybiBvZiBjb25zb2xlLmxvZyBmb3IgdW5zdXBwb3J0ZWRicm93c2VycyBhbmQgd2hlbiBkZWJ1ZyBpcyBzZXQgdG8gZmFsc2U7XHJcbnJlcXVpcmUoJy4vbW9kdWxlcy9fY29uc29sZScpO1xyXG5cclxuXHJcbiQoIGRvY3VtZW50ICkucmVhZHkoZnVuY3Rpb24oKSB7XHJcblx0Y29uc29sZS5sb2coJ0VlbnZvdWQgRm91bmRldGlvbicpO1xyXG5cdC8vJCgnbmF2I21haW4tbmF2IGEnKS5zbW9vdGhTY3JvbGwoe29mZnNldDogLTM0fSk7XHJcblx0Xy5lYWNoKEFwcC5yZXNpemVycywgZnVuY3Rpb24ocmVzaXplcikge1xyXG5cdFx0cmVzaXplcigpO1xyXG5cdH0pO1xyXG5cclxuXHRcclxufSk7XHJcblxyXG4kKHdpbmRvdykubG9hZChmdW5jdGlvbigpIHtcclxuXHRBcHAuaW5pdGlhbGl6ZWQgPSB0cnVlO1xyXG5cdC8vY29uc29sZS5sb2coQXBwLmluaXRpYWxpemVkKTtcclxuXHRcclxuXHRfLmVhY2goQXBwLnJlc2l6ZXJzLCBmdW5jdGlvbihyZXNpemVyKSB7XHJcblx0XHRyZXNpemVyKCk7XHJcblx0fSk7XHJcblxyXG59KTtcclxuXHJcbnZhciByZXNpemVUaW1lcjtcclxuXHJcbiQod2luZG93KS5yZXNpemUoZnVuY3Rpb24oKSB7XHJcblx0Y2xlYXJUaW1lb3V0KHJlc2l6ZVRpbWVyKTtcclxuXHRyZXNpemVUaW1lciA9IHNldFRpbWVvdXQoZnVuY3Rpb24oKSB7XHJcblx0XHRfLmVhY2goQXBwLnJlc2l6ZXJzLCBmdW5jdGlvbihyZXNpemVyKSB7XHJcblx0XHRcdHJlc2l6ZXIoKTtcclxuXHRcdH0pO1xyXG5cdH0sMTAwKTtcclxufSk7XHJcbiJdfQ==